import pluralize from "pluralize";
import React, { FC, useContext } from "react";

import { css } from "@emotion/react";
import { DiscountQuantityButtonType } from "@intelligems/ig-types/src/dtos/deprecated/discounts";

import { DiscountQuantityContext } from "../context";

interface PriceSectionProps {
  button: DiscountQuantityButtonType;
  discountedUnitPrice: string;
}

export const PriceSection: FC<PriceSectionProps> = ({
  button,
  discountedUnitPrice,
}) => {
  const { theme, config, isMobile, getWidgetConfig } = useContext(
    DiscountQuantityContext
  );

  const priceSectionClass = css`
    margin: ${theme.priceSection.margin};
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-content: space-around;
    justify-items: center;
    align-items: center;
    height: 100%;
  `;

  return (
    <div className={"ig-volume-widget-price-section"} css={priceSectionClass}>
      <div
        css={css`
          text-align: center;
        `}
      >
        <div
          className={`ig-volume-widget-price-section-text`}
          css={css`
            margin-bottom: 3px;
          `}
        >
          {isNaN(button.quantity) ? "1" : button.quantity}{" "}
          {button.unitName || pluralize("units", button.quantity || 0)}
        </div>
        <div className={"ig-volume-widget-price-section-text"}>
          <span
            className={"ig-volume-widget-price-section-price"}
            css={css`
              font-weight: 600;
            `}
          >
            {discountedUnitPrice}{" "}
            <span className={"ig-volume-widget-price-section-each"}>
              {getWidgetConfig("variables.textReplacements.each")}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
